<template>
<v-layout class="fill-height">
  <v-container
    id="contentDashboard" fluid
    class="fill-height"
  >
    <v-layout>
      <v-row
        align="start"
        justify="start"
      >
        <v-col cols="12" class="pt-1">
          <header-sidebar></header-sidebar>
            <v-card class="elevation-0 text-left pa-4" style="background:transparent;     width: 99%;">
                <v-card-title><h2><b> Messages</b></h2></v-card-title>
                <v-row style="margin: 0 auto;">
                    <v-col md="4" class="pr-9" style="overflow-y: auto; height: 720px;">
                        <v-list style="background:transparent;" three-line>
                            <template v-for="(item, index) in messages">
                                <v-subheader
                                v-if="item.header"
                                :key="item.header"
                                v-text="item.header"
                                ></v-subheader>

                                <v-divider
                                v-else-if="item.divider"
                                :key="index"
                                :inset="item.inset"
                                ></v-divider>
                                <template v-else>
                                <v-hover v-slot="{ hover }"  v-bind:key="item.id">
                                <v-list-item
                                :to="{name: 'dashboardMessages', query: {id: item.id}}"
                                exact
                                active-class="active-conversation"
                                :class="{ 'hovered-conversation': hover }"
                                :key="item.title"
                                class="my-2 conversation"
                                >
                                
                                    <v-list-item-content>
                                        <v-list-item-title :class="{ 'white--text': hover }" style="font-weight:700; line-height:32px;">{{item.object}}</v-list-item-title>
                                        <v-list-item-subtitle :class="{ 'white--text': hover }" style="font-weight:700; color:rgb(18 135 249);" v-html="item.datetime"></v-list-item-subtitle>
                                        <v-list-item-subtitle :class="{ 'white--text': hover }" v-html="item.content"></v-list-item-subtitle>
                                    </v-list-item-content>
                                

                                </v-list-item>
                                </v-hover>
                                </template>
                            </template>
                        </v-list>
                    </v-col>
                    <v-col v-if="$route.query.id" md="8" class="pa-0">
                            <v-toolbar class="elevation-0" style="background:transparent;">
                                <v-toolbar-title><b>{{message.object}} - Anonyme</b></v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-btn icon>
                                    <v-icon>mdi-magnify</v-icon>
                                </v-btn>
                                <v-btn icon>
                                    <v-icon>mdi-reply</v-icon>
                                </v-btn>
                                <v-btn icon>
                                    <v-icon>mdi-delete</v-icon>
                                </v-btn>
                            </v-toolbar>
                            <div class="pa-4">
                                <div class="bull-customer" v-html="message.content"></div>
                                <vue-editor v-model="text"></vue-editor>
                            </div>
                    </v-col>
                </v-row>
            </v-card>          
        </v-col>
      </v-row>
    </v-layout>
  </v-container>
</v-layout>
</template>

<script>
import headerSidebar from '../commons/header_sidebar.component'
import VueJwtDecode from "vue-jwt-decode"
import profile_picture from '../../../assets/profile_picture.png'
import { VueEditor } from "vue2-editor";

export default {
  name: 'messages-dashboard',
  props:['permissions'],
  components: {headerSidebar, VueEditor},
  data: () => ({
    drawer: true,
    mini: false,
    profile_picture_standard: profile_picture,
    search: '',
    expanded: [],
    drawerClass: '',
    message: {},
    dialog: false,
    item: {},
    messages: [
        { header: 'Aucune conversation n\'est trouvée.' },
    ],
    email: '',
    user: '',
    last_connect: '',
    userdata: {},
    text: ''
 
  }),
  async created(){
    this.setUser()
    this.userdata = Object.assign(VueJwtDecode.decode(this.$store.getters.getUser).userData, {agent: {}})
      if(this.userdata.agent_id > 0){
          await this.axios
              .get('/agent/listing')
              .then(res =>
              {
                  let agentList = res.data
                  this.userdata.agent = agentList.filter(v => { return v.id === this.userdata.agent_id } )[0]
              })
      }
    
  },
  watch: {
      $route() {
            this.setUser()
        }
  },
  
   mounted(){
    this.email = VueJwtDecode.decode(this.$store.getters.getUser).userData.email
    this.user = VueJwtDecode.decode(this.$store.getters.getUser).userData.username
    this.last_connect = VueJwtDecode.decode(this.$store.getters.getUser).userData.last_connect
        
  },
  methods: {
      async setUser(){
        let self = this
        await this.axios
        .get("/messages/listing")
        .then(res =>{
            if(res.data.length > 0){
                this.messages = []
                let today = 0
                let lastweek = 0 
                let before = 0
               
                this.messages.push({ header: 'Aujourd\'hui' })
                res.data.forEach((item, key) => {
                    let diff = new Date().getTime() - new Date(item.creation_date).getTime()
                    let d = new Date(item.creation_date)
                    if(diff < 86400000 ){
                        today = today+1
                        d.getHours() // => 9
                        d.getMinutes()
                        item.datetime = 'Reçu à '+d.toLocaleTimeString().substr(0, 5)
                        
                        this.messages.push(item)
                    }else if(diff < 604800000 && diff >=  86400000){
                        if(today == 0 && today !== -1){
                            today = -1
                            this.messages.splice(key, 1)
                            
                        }
                        if(lastweek === 0){
                            this.messages.push({ header: 'Cette Semaine' })
                        }
                        lastweek = lastweek + 1
                        this.messages.push(item)
                    }else{
                        if(before == 0){
                            this.messages.push({ header: 'Plus Tard' })
                        }
                        before = before+1
                        item.datetime = ("0" + d.getUTCDate()).slice(-2) + "/" +("0" + (d.getUTCMonth()+1)).slice(-2) + "/" +d.getUTCFullYear() + " " +("0" + d.getUTCHours()).slice(-2) + ":" +("0" + d.getUTCMinutes()).slice(-2)
                        this.messages.push(item)
                    }
                    if(this.$route.query.id){
                        if(item.id == this.$route.query.id){
                            this.message = item
                        }
                    }
                })
            }
            if(this.$route.query.id && !this.message.id){
                this.$router.replace({name:'dashboardMessages'})
            }
        })
        
      }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .conversation{
    border-radius:10px;
  }
  .bull-customer {
    background: #fdfdfd;
    box-shadow: rgba(0, 0, 0, 0.02) 0px 15px 15px;
    width: 65%;
    border-radius: 25px;
    padding: 21px;
    font-size: 90%;

  }
  .active-conversation {
    color:white !important;
    background: rgb(83,74,228);
    opacity:1;
    background: linear-gradient(21deg, rgba(83,74,228,1) 0%, rgba(0,212,255,0.9) 100%);
  }
  .active-conversation .v-list-item__subtitle{
      color: white !important;
  }
  .hovered-conversation{
    color:white !important;
    background: rgb(83,74,228);
    opacity:1;
    background: linear-gradient(21deg, rgba(83,74,228,1) 0%, rgba(0,212,255,0.9) 100%);
  }
  .v-list-item{
    transition: all ease-in-out  .4s;
  }
  .chart {
    position: absolute !important;
    left: 0;
    right: 0;
    top: -35px;
    margin: 0 auto;
    z-index: 0;
    width: fit-content;
  }
  .stat-num-unity{
    display:block;
    font-family: "Raleway", sans-serif;
    font-weight:700;
    position: relative;
    z-index: 3;
    transform: rotate(90deg) translateX(-70px) translateY(-80px);
  }
  .stat-unity {
    display:inline-block;
    font-family: "Raleway", sans-serif;
    font-weight:700;
    position: relative;
    z-index: 3;
  }
  .stat-title {
    font-weight:700;
    font-family: "Raleway", sans-serif;
    font-size:82px;
    position: relative;
    z-index: 3;
  }
  .stat-text-class {
    margin: 0 auto;
    color: gray;
    display: block;
  }
  .stat-class {
    position: absolute;
    z-index: 3;
    bottom: 25px;
    margin: 0 auto;
    color: gray;
  }
  .stat-num-title{
    font-weight:700;
    font-family: "Raleway", sans-serif;
    font-size:78px;
    position: relative;
    z-index: 3;
  }
  .filter-selectbox{
    margin-left: 16px;
    width: 63%;
  }
  h1, h2 {
    font-weight: normal;
  }
  .no-width {
    width: 0px !important;
    min-width: 0px !important;
    padding:25px 0px !important;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  }
  .table-content {
    margin: 0 auto;
    margin-top: 25px;
    width: 97.7%;
    .v-input__control{
      min-width: 210px;
    }
  }
  .second-sidebar {
    box-shadow: 0 0 35px rgba(0,0,0,0.05);
    min-width:360px;
    padding:25px;
  }
  .add-btn {
    background: #207ddd;
    box-shadow: 5px 10px 20px #207ddd40;
    font-size: 12px;
  }
  .toggle-second-sidebar {
    float: left;
    width: 48px;
    height: 48px;
    top: 89px;
    transform: translateX(-24px);
    font-size:12px;
    background: white;
    border: 1px solid rgba(0,0,0,0.1);
    .toggle-icon {
      margin-left:15px;
    }
  }
  .main-dashboard-toolbar {
    background: transparent !important;
    padding-left: 15px;
  }
  .v-list--three-line .v-list-item, .v-list-item--three-line {
    min-height: 35px !important;
  }
  .v-list--rounded.v-list--three-line .v-list-item, .v-list--rounded.v-list--three-line .v-list-item:before, .v-list--rounded.v-list--three-line .v-list-item>.v-ripple__container {
      border-radius: 0px !important;
  }
  .v-list-item {
    text-align: left;
  }
  .v-list-item__title {
    font-size: 15px !important;
  }
  .v-list--nav .v-list-item:not(:last-child):not(:only-child), .v-list--rounded .v-list-item:not(:last-child):not(:only-child){
    margin-bottom: 0px !important;
  }
  .v-list-item__content{
    text-align: left !important;
  }
  .v-data-table td, .v-data-table th{
    padding: 0px !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/dashboard/message/listing.vue